<template>
    <div class="codics-book-home">
        <div class="codics-book-header"
            :style="{ 'position': showFixedSearch ? 'fixed' : 'relative', 'background': showFixedSearch ? '#FFF' : 'rgba(0,0,0,0)', borderBottom: showFixedSearch ? '.1px solid rgba(0, 0, 0, .05);' : 'none' }">
            <div class="codics-book-header-content">
                <el-image class="codics-book-header-logo"
                    src="https://cdn.posto.cn/huayuan/img/yasuo_PicsArt_05-29-05.12.55.webp" fit="fill"></el-image>
                <el-menu :default-active="showIndex" class="codics-header-menu codics-book-header-menu"
                    mode="horizontal" @select="handleSelect" text-color="#333333" active-text-color="#333333">
                    <el-menu-item index="1">首页</el-menu-item>
                    <el-menu-item index="2">上传</el-menu-item>
                </el-menu>
                <el-avatar class="codics-book-header-himg" shape="square" :size="38"
                    :src="'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
                <el-button class="codics-book-header-vip-btn" type="info" plain><svg class="icon"
                        style="transform: scale(1.5);margin-right: 10px;" aria-hidden="true">
                        <use xlink:href="#icon-a-puka-huangguan2"></use>
                    </svg>开通会员</el-button>
                <el-input class="codics-book-header-search" v-model="searchTxt" placeholder="请输入内容">
                    <i class="el-icon-search el-input__icon" style="cursor: pointer;" slot="suffix">
                    </i>
                </el-input>
            </div>
        </div>
        <router-view></router-view>
        <BookFooter></BookFooter>
        <WebDialog height="60%" width="50%" ref="kfDialog" title="客服咨询"></WebDialog>
        <div class="codics-home-kf-box">
            <el-tooltip class="item" effect="dark" content="嘿，我来帮您！" placement="right">
                <el-image class="codics-home-kf-box-image"
                    src="http://demo.sucaihuo.com/jquery/22/2229/demo/images/en_3.png"
                    @click="showKfDialog();"></el-image>
            </el-tooltip>
        </div>
        <div class="codics-book-home-totop-box">
            <div class="codics-book-home-totop-card" style="top: 0;" v-show="showFixedSearch" @click="toTop">
                <div class="codics-book-home-totop-card-icon iconfont">&#xe846;</div>
            </div>
            <div class="codics-book-home-totop-card codics-book-home-totop-card-qr" style="bottom: 0;">
                <div class="codics-book-home-totop-card-icon iconfont">&#xe747;</div>
            </div>
            <el-image class="codics-book-home-totop-card-qrcode"
                src="data:image/png;base64,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"
                fit="fill"></el-image>
        </div>
    </div>
</template>

<script>
import BookFooter from '@/components/BookFooter';
import WebDialog from '@/components/WebDialog';
export default {
    data() {
        return {
            showIndex: '1',
            searchTxt: '',
            showFixedSearch: false
        }
    },
    mounted() {
        // 监听页面滚动事件
        window.addEventListener("scroll", this.showSearch);
    },
    methods: {
        showKfDialog() {

            this.$refs.kfDialog.toggleShow();

        },
        showSearch() {
            // 获取当前滚动条向下滚动的距离
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // 当页面滚动到高度300px处时，显示搜索框
            if (scrollTop > 60) {
                this.showFixedSearch = true;
            } else {
                this.showFixedSearch = false;
            }
        },
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
    },
    components: {
        BookFooter,
        WebDialog
    }
}
</script>

<style>
.codics-book-home {
    height: fit-content;
    width: 100% !important;
    box-sizing: border-box !important;
    position: relative;
    float: left;
}

.codics-book-header {
    height: 60px;
    width: 100%;
    float: left;
    z-index: 1000;
    top: 0;
    transition: .4s;
}

.codics-book-header-content {
    height: 100%;
    width: 100%;
    max-width: 1450px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

.codics-book-header-logo {
    height: 40px;
    width: 189.19px;
    position: relative;
    float: left;
    top: 10px;
    overflow: visible !important;
}

.codics-book-header-logo::before {
    content: '';
    height: 27px;
    width: 1px;
    position: absolute;
    right: -15px;
    margin: auto;
    top: 0;
    bottom: 0;
    background-color: #333;
}

.codics-book-header-menu {
    float: left !important;
    left: 15px !important;
    border-bottom: none !important;
}

.codics-book-header-menu .el-menu-item {
    border-bottom: none !important;
}

.codics-book-header-menu .is-active::after {
    content: '';
    height: 1px;
    width: calc(100% - 40px);
    position: absolute;
    margin: auto;
    top: 30px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #333;
}

.codics-book-header-search {
    position: relative;
    float: right;
    width: 200px !important;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 15px;
}

.el-input__inner:focus {
    border-color: #333 !important;
}

.codics-book-header-himg {
    position: relative;
    float: right;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 15px;
}

.codics-book-header-vip-btn {
    position: relative;
    float: right;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 15px !important;
}
</style>